import { atom } from 'jotai';

export type SecureInitParameters = {
  appId: string;
  destinationWallets: {
    address: string;
    assets?: string[];
    blockchains?: string[];
    supportedNetworks?: string[];
  }[];
  sessionUuid?: string;
  disableCryptoSend?: boolean;
};

export const secureInitParametersAtom = atom<SecureInitParameters | undefined>(undefined);
